<script>
  import { ignore } from "../../Common/tools";
  import ColorPicker from "../../Common/ColorPicker.svelte";
  import Slider from "../../Common/Slider.svelte";
  import {External, M} from "../../external";

  export let widget,
    onChange = ignore;
  let data = widget.data,
    widgetUi = widget.$widget;
  let fonts = External.GlobalStyling.getAvailableFontNames() || [];

  data.stepHeadlineSize = data.stepHeadlineSize || 34;
  data.stepSubHeadlineSize = data.stepSubHeadlineSize || 14;
  data.subHeadlineFont = data.subHeadlineFont || "Open Sans";
</script>

<div class="popup-widget-wrapper form-admin-style-2">
  <div class="input-wrapper mt-5">
    <div class="info">
      <h5>{M.HEADING_ALIGNMENT}</h5>
    </div>
    <select bind:value={data.position} on:change={onChange}>
      <option value="center">{M.CENTER}</option>
      <option value="left">{M.LEFT}</option>
    </select>
  </div>

  <div class="col20 f-left gray-section section-gray-box mt-5">
    <h4>{M.TITLE}</h4>
    <div class="input-wrapper mt-15">
      <div class="info">
        <h5>{M.FONT}</h5>
      </div>
      <select bind:value={data.headlineFont} on:change={onChange}>
        {#each fonts as font}
          <option value={font}>{font}</option>
        {/each}
      </select>
    </div>

    <div class="col20 f-left">
      <div class="input-wrapper col20 f-left color-pick-wrap-widgets">
        <ColorPicker bind:color={data.stepHeadlineColor} bind:colorClass={data.stepHeadlineColorClass} label={M.STEP_HEADING_COLOR} onChange={onChange} />
      </div>
    </div>

    <div class="input-wrapper col20 f-left">
      <Slider bind:value={data.stepHeadlineSize} min={1} max={100} label={M.QUIZ_STEP_HEADING_SIZE} onChange={onChange} />
    </div>
  </div>

  <div class="col20 f-left gray-section section-gray-box mt-15">
    <h4>{M.DESCRIPTION}</h4>
    <div class="input-wrapper mt-15">
      <div class="info">
        <h5>{M.FONT}</h5>
      </div>
      <select bind:value={data.subHeadlineFont} on:change={onChange}>
        {#each fonts as font}
          <option value={font}>{font}</option>
        {/each}
      </select>
    </div>

    <div class="col20 f-left">
      <div class="input-wrapper col20 f-left color-pick-wrap-widgets">
        <ColorPicker bind:color={data.stepSubHeadlineColor} bind:colorClass={data.stepSubHeadlineColorClass} label={M.STEP_DESCRIPTION_COLOR} onChange={onChange} />
      </div>
    </div>

    <div class="input-wrapper col20 f-left">
      <Slider bind:value={data.stepSubHeadlineSize} min={1} max={100} clz="" label={M.QUIZ_STEP_DESCRIPTION_SIZE} onChange={onChange} />
    </div>
  </div>
</div>
